export const getErrorMessage = (error, defaultMsg = "An error occurred") => {
  if (error.response && error.response.data && error.response.data.error) {
    return error.response.data.error;
  }
  return error.message || defaultMsg;
};
